import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const Home: React.FC = () => {
  const { isAuthenticated, user } = useAuth();

  return (
    <div className="max-w-4xl mx-auto">
      {/* Hero Section */}
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-6xl font-bold text-navy-950 dark:text-white mb-4">
          Navy Football Brotherhood
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
          Connecting Navy Football Alumni Worldwide
        </p>
        <div className="navy-gradient rounded-lg p-8 text-white">
          <h2 className="text-2xl font-bold mb-4">
            Welcome to the Brotherhood v2.0
          </h2>
          <p className="text-lg">
            Stay connected with your fellow Navy Football alumni, manage your profile,
            reserve game day seats, and be part of the continuing legacy.
          </p>
        </div>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        <div className="card">
          <div className="w-12 h-12 bg-navy-950 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-1.326-.571-2.376-1.3-3.014M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-1.326.571-2.376 1.3-3.014M16 11a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-navy-950 dark:text-white mb-2">
            Member Directory
          </h3>
          <p className="text-gray-600 dark:text-gray-300">
            Connect with fellow Navy Football alumni by class year, position, or location.
          </p>
        </div>

        <div className="card">
          <div className="w-12 h-12 bg-gold-950 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-navy-950 dark:text-white mb-2">
            Seat Reservations
          </h3>
          <p className="text-gray-600 dark:text-gray-300">
            Reserve your game day seats in the alumni section. Available weekly.
          </p>
        </div>

        <div className="card">
          <div className="w-12 h-12 bg-navy-950 rounded-lg flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-navy-950 dark:text-white mb-2">
            Profile Management
          </h3>
          <p className="text-gray-600 dark:text-gray-300">
            Keep your profile updated with current contact info and career details.
          </p>
        </div>
      </div>

      {/* Auth Status */}
      {isAuthenticated ? (
        <div className="card bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800">
          <h2 className="text-xl font-bold text-green-800 dark:text-green-200 mb-2">
            Welcome back, {user?.firstName}!
          </h2>
          <p className="text-green-700 dark:text-green-300">
            Class of {user?.classYear} | {user?.position || 'Navy Football Alumni'}
          </p>
        </div>
      ) : (
        <div className="card bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800">
          <h2 className="text-xl font-bold text-blue-800 dark:text-blue-200 mb-2">
            Join the Brotherhood
          </h2>
          <p className="text-blue-700 dark:text-blue-300 mb-4">
            Sign up or log in to connect with your fellow Navy Football alumni.
          </p>
          <div className="flex space-x-4">
            <a href="/register" className="btn-primary">
              Register
            </a>
            <a href="/login" className="btn-secondary">
              Login
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
